import React, {createContext, useContext, useEffect, useState} from 'react';
import {useDefaultEndpoints} from "./useDefaultEndpoints";
import {GlobalState} from "./globalState";

const BasesContext = createContext();

export const BasesProvider = ({ children }) => {
    const {getEntries} = useDefaultEndpoints('bases');
    const [globalState] = useContext(GlobalState);
    const [bases, setBases] = useState([]);

    useEffect(() => {
        getEntries({
            is_archived_ne: true,
            _sort: 'base_order:ASC',
            _or: [{ hide_in_menu_ne: true }, { hide_in_menu_null: true }]
        }).then(response => {
            setBases(response);
        }).catch(error => {
            console.error('Failed to load bases:', error);
        });
    }, [globalState.userId]);

    return (
        <BasesContext.Provider value={{bases}}>
            {children}
        </BasesContext.Provider>
    );
}

export const useBases = () => {
    return useContext(BasesContext);
};